module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateNewPicture[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagSaveNewPicture) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.textDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelPictureReferenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceName),
      expression: "referenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Refeference name"
    },
    domProps: {
      "value": (_vm.referenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referenceName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.labelFileType[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileType),
      expression: "fileType"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fileType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "jpg"
    }
  }, [_vm._v("JPEG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "png"
    }
  }, [_vm._v("PNG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bmp"
    }
  }, [_vm._v("BMP")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-md btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewPicture()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonCreatePicture[_vm.actualLanguage]))])])])])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h4', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.textPictureCreated[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.messageTransmitFile[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.newFileName))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.pictureList.length > 0) ? _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.overlayParameters.pictureType === 'channel') ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelTableChannel[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.overlayParameters.pictureType === 'device') ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelTableDevice[_vm.actualLanguage]))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.pictureList), function(Picture) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Picture.pictureReferenceName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Picture.fileName))])])
  }), 0)])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Nom reference / Reference Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Nom fichier / Filename")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23793242","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/OrganizationApiAddPictureForm.vue
// module id = 1499
// module chunks = 4